import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useIsSubscribed, useToggleEmailSubscription } from "@/hooks/use-email-subscriptions";
import { Bell } from "lucide-react";

export const EmailNotificationPreferences = () => {
  const isSubscribedToReleases = useIsSubscribed('release_notes');
  const isSubscribedToOutages = useIsSubscribed('outage_notifications');
  const toggleSubscription = useToggleEmailSubscription();

  const handleToggleReleaseNotes = (checked: boolean) => {
    toggleSubscription.mutate({
      subscriptionType: 'release_notes',
      isSubscribed: checked
    });
  };

  const handleToggleOutages = (checked: boolean) => {
    toggleSubscription.mutate({
      subscriptionType: 'outage_notifications',
      isSubscribed: checked
    });
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Bell className="h-5 w-5 text-primary" />
          <CardTitle>Notification Preferences</CardTitle>
        </div>
        <CardDescription>
          Manage your email notification settings
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between space-x-2">
          <div className="flex-1 space-y-1">
            <Label htmlFor="release-notes" className="text-sm font-medium">
              Release Notifications
            </Label>
            <p className="text-sm text-muted-foreground">
              Receive email notifications when new releases are published
            </p>
          </div>
          <Switch
            id="release-notes"
            checked={isSubscribedToReleases}
            onCheckedChange={handleToggleReleaseNotes}
            disabled={toggleSubscription.isPending}
          />
        </div>
        
        <div className="flex items-center justify-between space-x-2">
          <div className="flex-1 space-y-1">
            <Label htmlFor="outage-notifications" className="text-sm font-medium">
              Outage Notifications
            </Label>
            <p className="text-sm text-muted-foreground">
              Receive email alerts when service outages occur or are resolved
            </p>
          </div>
          <Switch
            id="outage-notifications"
            checked={isSubscribedToOutages}
            onCheckedChange={handleToggleOutages}
            disabled={toggleSubscription.isPending}
          />
        </div>
      </CardContent>
    </Card>
  );
};
